<template>
    <div>
       c Fail d
    </div>
</template>

<script>
import axios from 'axios'
export default{
    name: 'payufail',
    data(){
        return{
            //
        }
    },
    created() {
        //
    },
}
</script>
